import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import styled from 'styled-components';

const StyledSnackbar = styled(Snackbar)`
  .MuiAlert-root {
    font-family: 'Poppins', sans-serif;
    border-radius: 8px;
  }
`;

const CustomSnackbar = ({ open, message, severity, onClose }) => {
  return (
    <StyledSnackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </StyledSnackbar>
  );
};

export default CustomSnackbar; 